export const cardDefaults = {
  amex: {
    name: "American Express",
    length: 15,
    cvv: 4,
    prefix: [34, 37],
    pattern: [4, 6, 5],
  },
  china: {
    name: "China UnionPay",
    length: [16, 19],
    cvv: 3,
    prefix: 62,
    pattern: [
      [4, 4, 4, 4],
      [6, 13],
    ],
  },
  discover: {
    name: "Discover",
    length: 16,
    cvv: 3,
    prefix: [6011, [622126, 622925], [644, 649], 65],
    pattern: [4, 4, 4, 4],
  },
  jcb: {
    name: "JCB",
    length: 16,
    cvv: 3,
    prefix: [[3528, 3589]],
    pattern: [4, 4, 4, 4],
  },
  mc: {
    name: "MasterCard",
    length: 16,
    cvv: 3,
    prefix: [
      [51, 55],
      [2221, 2720],
    ],
    pattern: [4, 4, 4, 4],
  },
  uatp: {
    name: "UATP",
    length: 15,
    cvv: 3,
    prefix: 1,
    pattern: [4, 5, 6],
  },
  dc: {
    name: "Diners Club International",
    length: 14,
    cvv: 3,
    prefix: [[300, 305], 309, 36, [38, 39]],
    pattern: [4, 6, 4],
  },
  visa: {
    name: "Visa",
    length: [16, 19],
    cvv: 3,
    prefix: [4, 4026, 417500, 4405, 4508, 4844, 4913, 4917],
    pattern: [
      [4, 4, 4, 4],
      [6, 4, 8, 1],
    ],
  },
};
